import type { ReactNode } from "react";

export const CaptureDialogPanels = ({ children }: { children: ReactNode }) => {
  return <div className="capture-dialog-panels">{children}</div>;
};
